<script setup lang="ts">
  import { useDisplay } from "vuetify";

  interface Props {
    note?: string;
    isSub?: boolean;
  }
  withDefaults(defineProps<Props>(), {
    note: "",
    isSub: false,
  });

  // レスポンシブ対応
  const { name } = useDisplay();
  const isSp = computed<boolean>(() => name.value === "xs");
  const headingFontSize = computed<string>(() => (isSp.value ? "14px" : "16px"));
  const noteFontSize = computed<string>(() => (isSp.value ? "12px" : "14px"));
  const noteFontWeight = computed<string>(() => (isSp.value ? "500" : "700"));
</script>

<template>
  <v-row justify="center" class="white mt-1 mb-1">
    <v-col :cols="note ? 5 : 12" justify="start">
      <div :class="[isSub ? 'item-subheading' : 'item-heading text-wrap']">
        <slot></slot>
      </div>
    </v-col>
    <v-col v-if="note" cols="7" justify="end">
      <div class="item-note">{{ note }}</div>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
  .item-heading {
    font-size: v-bind("headingFontSize");
    font-weight: 700;
    text-align: left;
    line-height: 1.8em;
    letter-spacing: 0.06em;
  }

  .item-subheading {
    font-size: v-bind("headingFontSize");
    font-weight: 400;
    text-align: left;
  }

  .item-note {
    font-size: v-bind("noteFontSize");
    font-weight: v-bind("noteFontWeight");
    text-align: right;
  }
</style>
